export enum ProductAllowanceEnum {
    Unknown,
    NotListed,
    Acceptable,
    Banned,
}
